export const darkTheme = {
  bg: '#15171E',
  bgLight: '#1C1E27',
  primary: '#f55874',
  text_primary: '#F2F3F4',
  text_secondary: '#b1b2b3',
  card: '#1c1c1c',
  button: '#5c5b5b',
  scroll_primary_bg: '#F2F3F4',
  scroll_primary_color: '#111111',
};

export const lightTheme = {
  bg: '#FFFFFF',
  bgLight: '#f0f0f0',
  primary: '#f55874',
  text_primary: '#111111',
  text_secondary: '#48494a',
  card: '#FFFFFF',
  button: '#5c5b5b',
  scroll_primary_bg: '#111111',
  scroll_primary_color: '#F2F3F4',
};
